<template>
    <div class="observations-field">
        <Textarea
            :id="inputId"
            :rows="rows"
            :disabled="disabled"
            :maxlength="maxLength"
            :modelValue="modelValue"
            @update:modelValue="onInput"
        />
        <!-- El contador solo tiene sentido mientras se puede escribir -->
        <small v-if="!disabled" :class="counterClass">
            {{ used }}/{{ maxLength }} caracteres<span v-if="atLimit"> · límite alcanzado</span>
        </small>
    </div>
</template>

<script>
/**
 * Campo de observaciones con límite visible.
 *
 * El tope lo declara el modelo del backend (Sale y Proforma 400, RemisionGuide 300)
 * y de ahí baja al XML del SRI y al RIDE: si el texto se pasa, el comprobante lo
 * recorta. Por eso el límite se avisa aquí, mientras se escribe, en vez de que el
 * usuario lo descubra al ver el PDF.
 */
export default {
    name: 'ObservationsField',

    props: {
        modelValue: { type: String, default: '' },
        maxLength: { type: Number, required: true },
        disabled: { type: Boolean, default: false },
        rows: { type: Number, default: 2 },
        inputId: { type: String, default: 'observations' },
    },

    emits: ['update:modelValue'],

    computed: {
        used() {
            return (this.modelValue || '').length;
        },
        remaining() {
            return this.maxLength - this.used;
        },
        atLimit() {
            return this.remaining <= 0;
        },
        nearLimit() {
            // Se avisa en el último 10% del campo, con un mínimo de 20 caracteres
            return this.remaining > 0 && this.remaining <= Math.max(20, Math.round(this.maxLength * 0.1));
        },
        counterClass() {
            return [
                'observations-counter',
                { 'observations-counter--warning': this.nearLimit },
                { 'observations-counter--full': this.atLimit },
            ];
        },
    },

    methods: {
        onInput(value) {
            // `maxlength` ya frena el tecleo y el pegado, pero un valor puesto por
            // código no pasa por ahí: se recorta para no enviar de más al backend.
            const text = value || '';
            this.$emit('update:modelValue', text.length > this.maxLength ? text.slice(0, this.maxLength) : text);
        },
    },
}
</script>

<style scoped lang="scss">
.observations-field {
    display: flex;
    flex-direction: column;
}

.observations-counter {
    align-self: flex-end;
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--text-color-secondary);
}

.observations-counter--warning {
    color: var(--orange-500);
}

.observations-counter--full {
    color: var(--red-500);
    font-weight: 600;
}
</style>
